module.exports = __webpack_public_path__ + "img/minipack-inactive.88a51a34.svg";